import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminAthletesService {
  static TIME_FRAMES = ['ALL', 'LAST_MONTH', 'LAST_YEAR']

  constructor() {
    this.endpoints = createPrefix('/admin/athletes', {
      search: '/search',
    })
  }

  static create() {
    return new AdminAthletesService()
  }

  async queryAthletes(params) {
    const servicePath = this.endpoints.search()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getAthleteById(id) {
    const servicePath = this.endpoints()
    const { data } = await axios.get(`${servicePath}/${id}`)
    return data
  }

  async createAthlete(athleteDTO) {
    const servicePath = this.endpoints()
    const { data } = await axios.post(servicePath, athleteDTO)
    return data
  }

  async updateAthlete(athleteDTO) {
    const servicePath = this.endpoints()
    const { data } = await axios.put(servicePath, athleteDTO)
    return data
  }

  async removeAthleteById(id) {
    const servicePath = this.endpoints()
    const { data } = await axios.delete(`${servicePath}/${id}`)
    return data
  }

  async getAthleteInfoById(id) {
    return this.getAthleteById(id)
  }

  async getTeamsForAthlete(athleteId, params) {
    const servicePath = this.endpoints()
    const { data } = await axios.get(`${servicePath}/${athleteId}/teams`, { params })
    return data
  }

  async addAthleteToTeam(params) {
    const servicePath = this.endpoints()
    const { id, teamId } = params
    const { data } = await axios.put(`${servicePath}/${id}/teams/${teamId}`, {})
    return data
  }

  async removeAthleteFromTeam(params) {
    const servicePath = this.endpoints()
    const { id, teamId } = params
    const { data } = await axios.delete(`${servicePath}/${id}/teams/${teamId}`)
    return data
  }
}
